export default __webpack_public_path__ + "static/icon-20-4-2e10830307f320b94578eca5abe22339.png";